// ======================================================================
// File Name       : UnsubmittedReportList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Table, Button, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import TableHead from '../../TableHead';
import * as unsubmittedReportAction from '../../../actions/report/UnsubmittedReportAction';
import {
  DEFAULT_DATE_FROM,
  DEFAULT_DATE_TO,
  DEFAULT_DATE_TO_TEXT,
  DEFAULT_DATE_FROM_TEXT,
  DEFAULT_DATE_FORMAT,
} from '../../../constants/index';
import { parseDateForDetail } from '../../../utils/index';
import PaginationCustom from '../../Pagination';

class UnsubmittedReportList extends React.Component {
  constructor(props) {
    super(props);
    this.handleSortState = this.handleSortState.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
  }
  /**
   * handle sorting data
   * @param {*} row
   */
  handleSortState(row) {
    const { dispatch, unsubmittedReport } = this.props;
    const { unsubmittedReportList } = unsubmittedReport;
    const { searchInfo} = unsubmittedReportList;
    searchInfo.reportHistorySortType = row.sortBy;
    searchInfo.ascendingDescendingSort = row.sortState;
    dispatch(unsubmittedReportAction.updateUnsubmittedReportSearchInfo(searchInfo));
    dispatch(unsubmittedReportAction.searchUnsubmittedReport());
  }

  /**
     * Pagination
     * @param {*} startPosition
     */
  getStartEndData(startPosition) {
    const { dispatch, unsubmittedReport } = this.props;
    const { unsubmittedReportList } = unsubmittedReport;
    const { searchInfo } = unsubmittedReportList;
    searchInfo.startPosition = startPosition;
    dispatch(unsubmittedReportAction.updateUnsubmittedReportSearchInfo(searchInfo));
    dispatch(unsubmittedReportAction.searchUnsubmittedReport());
  }

  render() {
    const { unsubmittedReport } = this.props;
    const { unsubmittedReportList } = unsubmittedReport;
    const { unsubmittedReportListResult, searchInfo, recordNum } = unsubmittedReportList;
    const { startPosition } = searchInfo;
    const thead = [
      { title: 'レポート名', sortBy: null },
      { title: 'ユーザー(提出者)', sortBy: null },
      { title: '提出期限', sortBy: null },
      { title: '結果返却予定日', sortBy: 3 },
    ];
    const unsubmittedReportListTable =
      unsubmittedReportListResult &&
      unsubmittedReportListResult.length > 0 &&
      unsubmittedReportListResult.map((report, index) => {
        const reportDeadline = parseDateForDetail(report.reportDeadline, DEFAULT_DATE_FORMAT, DEFAULT_DATE_TO_TEXT);

        const reportReturnPlanDate = parseDateForDetail(report.reportReturnPlanDate, DEFAULT_DATE_FORMAT, DEFAULT_DATE_FROM_TEXT);
        return (
          <tr key={index}>
            <td>{report.reportName}</td>
            <td>{report.userName}</td>
            <td>{reportDeadline}</td>
            <td>{reportReturnPlanDate}</td>
          </tr>
        );
      });
    return (
      <div id="UnsubmittedReportListTable">
        <Table striped hover>
          <thead>
            <TableHead data={thead} handleSortState={this.handleSortState} />
          </thead>
          <tbody>{unsubmittedReportListTable}</tbody>
        </Table>
        <Col className="margin-bottom-10 d-flex justify-content-center">
          <PaginationCustom
            recordNum={recordNum}
            handlePageSelect={this.getStartEndData}
            startPosition={startPosition}
          />
        </Col>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { form, unsubmittedReport } = state;
  return {
    unsubmittedReport,
  };
};

export default connect(mapStateToProps)(UnsubmittedReportList);
